<template>
  <div class="table-header">
    <table-header-cell
      v-for="item in visibleProps"
      :key="item.key"
      :item="item"
      :draggable="draggable && item.draggable"
      @width-changed="widthChanged"
      @dragstart="$emit('cell-dragstart', $event)"
      @drag="$emit('cell-drag', $event)"
      @dragend="$emit('cell-dragend', $event)"
    />
    <div
      v-if="hasEmptyRow"
      class="_empty-row"
    />
  </div>
</template>

<script>
import TableHeaderCell from '@/components/table/TableHeaderCell.vue';
import { VIEWS_SERVICE } from '@/lib/constants';
import { inject } from 'vue';

export default {
  name: 'TableHeader',
  props: {
    visibleProps: {
      type: Array,
      required: true,
    },
    props: {
      type: Array,
      required: true,
    },
    hasEmptyRow: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const viewsService = inject(VIEWS_SERVICE);
    return { viewsService };
  },
  emits: ['cell-dragstart', 'cell-drag', 'cell-dragend'],
  components: { TableHeaderCell },
  methods: {
    widthChanged(prop) {
      const updatedProps = this.props.map((p) => {
        if (p.key !== prop.key) {
          return p;
        }

        return prop;
      });
      this.viewsService.setParams(
        this.viewsService.currentView.value,
        {
          ...this.viewsService.currentView.value.params,
          props: updatedProps,
        },
      );
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .table-header {
    display: inline-flex;
    background-color: white;
    border-top: 1px solid $border-color;
    border-bottom: 1px solid $border-color;

    ._empty-row {
      flex: 1 0 3.2rem;
    }
  }
</style>
